import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '../store'

import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import DetailView from '../views/DetailView.vue'
import PrivacyPolicyIntranetView from '../views/PrivacyPolicyIntranetView.vue'
import AbsenPegawaiHomeView from '../views/AbsenPegawai/HomeView.vue'
import AllRekapanView from '../views/AbsenPegawai/AllRekapanView.vue'
import RekapanView from '../views/AbsenPegawai/RekapanView.vue'
import HariniView from '../views/AbsenPegawai/HariniView.vue'
import WfaOrWfhView from '../views/AbsenPegawai/WfaOrWfhView.vue'
import ListAllWfaOrWfhOrFwa from '../views/AbsenPegawai/ListAllWfaOrWfhOrFwa.vue'
import JadwalWfaOrWfhView from '../views/AbsenPegawai/JadwalWfaOrWfhView.vue'
import PerbulanView from '../views/AbsenPegawai/PerbulanView.vue'
import ProfilePegawaiHomeView from '../views/ProfilePegawai/HomeView.vue'
import ManajemenPengumumanHomeView from '../views/ManajemenPengumuman/HomeView.vue'
import DeviceManagementHomeView from '../views/DeviceManagement/HomeView.vue'
import AllDevicesView from '../views/DeviceManagement/AllDevicesView.vue'
import ActivityLogsHomeView from '../views/ActivityLogs/HomeView.vue'
import RoleManagementHomeView from '../views/RoleManagement/HomeView.vue'
import MenuManagementHomeView from '../views/MenuManagement/HomeView.vue'
import TopicManagementHomeView from '../views/TopicManagement/HomeView.vue'
import CategoryManagementView from '../views/TopicManagement/CategoryManagementView.vue'
import PengaturanHomeView from '../views/Pengaturan/HomeView.vue'
import PengaturanUmum from '../views/Pengaturan/PengaturanUmumView.vue'
import PengaturanAbsensi from '../views/Pengaturan/PengaturanAbsensiView.vue'
import PengaturanNotifikasi from '../views/Pengaturan/PengaturanNotifikasiView.vue'
import PengaturanKeamanan from '../views/Pengaturan/PengaturanKeamananView.vue'
import InformasiSistem from '../views/Pengaturan/InformasiSistemView.vue'
import ProfilePegawai from '../views/Pengaturan/ProfilePegawaiView.vue'
import RoleManagement from '../views/Pengaturan/RoleManagementView.vue'
import UserManagement from '../views/Pengaturan/UserManagementView.vue'
import VersionMobileView from '../views/Pengaturan/VersionMobileView.vue'
import MenuManagement from '../views/Pengaturan/MenuManagementView-0.vue'
import AplikasiView from '../views/Pengaturan/AplikasiView.vue'
import MaintenanceView from '../views/MaintenanceView.vue'
import AbsenEventView from '../views/AbsenEvent/HomeView.vue'
import EventCheckInView from '../views/AbsenEvent/CheckInView.vue'
import AttendanceForm from '../views/AttendanceForm.vue'
import FeedbackView from '../views/FeedbackManagement/HomeView.vue'
import SSOAuthorizeView from '../views/SSOAuthorizeView.vue'
import SSODocumentationView from '../views/SSODocumentationView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { 
      requiresVisitor: true
    }
  },
  {
    path: '/attendance/:id',
    name: 'attendance_form',
    component: AttendanceForm,
    meta: {
      // No auth required - public access for QR code scanning
    }
  },
  {
    path: '/events/checkin',
    name: 'event_checkin',
    component: EventCheckInView,
    meta: {
      // No auth required - public access for event check-in via QR code
      public: true
    }
  },
  {
    path: '/privacy-policy-intranet',
    name: 'PrivacyPolicyIntranet',
    component: PrivacyPolicyIntranetView,
    meta: { 
      requiresVisitor: true
    }
  },
  {
    path: '/sso/authorize',
    name: 'sso_authorize',
    component: SSOAuthorizeView,
  },
  {
    path: '/sso/documentation',
    name: 'sso_documentation',
    component: SSODocumentationView,
    meta: {
      title: 'SSO Integration Guide'
    }
  },
  {
    path: '/dashboard',
    // name: 'about',
    component: AboutView,
    children: [
      {
        path: '/',
        name: 'detail',
        component: DetailView,
        meta: { 
          requiresAuth: true
        }
      },
      {
        path: '/KboDGentICHR',
        // name: 'absen_pegawai',
        component: AbsenPegawaiHomeView,
        meta: { 
          requiresAuth: true
        },
        children: [
          {
            path: '/t15M4szIx3Ux',
            name: 'all_rekapan',
            component: AllRekapanView,
            meta: { 
              requiresAuth: true
            }
          },
          {
            path: '/',
            name: 'rekapan',
            component: RekapanView,
            meta: { 
              requiresAuth: true
            }
          },
          {
            path: '/e8YA0E9R5cdn',
            name: 'hari_ini',
            component: HariniView,
            meta: { 
              requiresAuth: true
            }
          },
          {
            path: '/oIrSx1N515dP',
            name: 'wfa_or_wfh',
            component: WfaOrWfhView,
            meta: { 
              requiresAuth: true
            }
          },
          {
            path: '/l3qcI09c2Mdj',
            name: 'jadwal_wfa_or_wfh',
            component: JadwalWfaOrWfhView,
            meta: { 
              requiresAuth: true
            }
          },
          {
            path: '/mOcDZwljZp',
            name: 'list_all_wfa_or_wfh',
            component: ListAllWfaOrWfhOrFwa,
            meta: { 
              requiresAuth: true
            }
          },
          {
            path: '/2xofcF5tq5Gj/GkCMz0QE329m/:id',
            name: 'per_bulan',
            component: PerbulanView,
            meta: { 
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: '/jxsetjrlujmg',
        name: 'AbsenEventView',
        component: AbsenEventView,
        meta: { 
          requiresAuth: true
        }
      },
      {
        path: '/irAmPApENtIo',
        name: 'profile_pegawai',
        component: ProfilePegawaiHomeView,
        meta: { 
          requiresAuth: true
        }
      },
      {
        path: '/DN7hpHJ13aSa',
        name: 'manajemen_pengumuman',
        component: ManajemenPengumumanHomeView,
        meta: { 
          requiresAuth: true
        }
      },
      {
        path: '/device-management',
        name: 'device_management',
        component: DeviceManagementHomeView,
        meta: { 
          requiresAuth: true
        }
      },
      {
        path: '/all-devices',
        name: 'all_devices',
        component: AllDevicesView,
        meta: { 
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '/activity-logs',
        name: 'activity_logs',
        component: ActivityLogsHomeView,
        meta: { 
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '/role-management',
        name: 'role_management',
        component: RoleManagementHomeView,
        meta: { 
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '/menu-management',
        name: 'menu_management',
        component: MenuManagementHomeView,
        meta: { 
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '/topic-management',
        name: 'topic_management',
        component: TopicManagementHomeView,
        meta: { 
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '/topic-categories',
        name: 'topic_categories',
        component: CategoryManagementView,
        meta: { 
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: FeedbackView,
        meta: { 
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: '/pengaturan',
        // name: 'pengaturan',
        component: PengaturanHomeView,
        meta: { 
          requiresAuth: true,
          requiresAdmin: true
        },
        children: [
          {
            path: '/pengaturan/228VuA0te0H0',
            name: 'PengaturanUmum',
            component: PengaturanUmum,
            meta: { 
              requiresAuth: true
            }
          },
          {
            path: '/pengaturan/MH6b6L04ioB7',
            name: 'PengaturanAbsensi',
            component: PengaturanAbsensi,
            meta: { 
              requiresAuth: true
            }
          }, 
          {
            path: '/pengaturan/GtUF24246anD',
            name: 'PengaturanNotifikasi',
            component: PengaturanNotifikasi,
            meta: { 
              requiresAuth: true
            }
          }, 
          {
            path: '/pengaturan/0386YQcijg0B',
            name: 'PengaturanKeamanan',
            component: PengaturanKeamanan,
            meta: { 
              requiresAuth: true
            }
          }, 
          {
            path: '/pengaturan/Y7K6MBnm9AuZ',
            name: 'InformasiSistem',
            component: InformasiSistem,
            meta: { 
              requiresAuth: true
            }
          }, 
          {
            path: '/',
            name: 'ProfilePegawai',
            component: ProfilePegawai,
            meta: { 
              requiresAuth: true
            }
          }, 
          {
            path: '/pengaturan/N9c0UU698qaY',
            name: 'RoleManagement',
            component: RoleManagement,
            meta: { 
              requiresAuth: true
            }
          }, 
          {
            path: '/pengaturan/r2AFmK0x0vql',
            name: 'UserManagement',
            component: UserManagement,
            meta: { 
              requiresAuth: true
            }
          }, 
          {
            path: '/pengaturan/p4EpnB87mI7O',
            name: 'MenuManagement',
            component: MenuManagement,
            meta: { 
              requiresAuth: true
            }
          },
          {
            path: '/pengaturan/p4EpnB87mI7',
            name: 'VersionMobile',
            component: VersionMobileView,
            meta: { 
              requiresAuth: true
            }
          },
          {
            path: '/pengaturan/apl1kas1s3tt1ng',
            name: 'AplikasiSetting',
            component: AplikasiView,
            meta: { 
              requiresAuth: true
            }
          }, 
        ] 
      },  
    ]
    // meta: { 
    //   requiresAuth: true
    // }
  },
  {
    path: '/9cjEqRxM64n1',
    name: 'hari_ini_mobile',
    component: HariniView,
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: MaintenanceView
  },
  {
    path: '*',
    name: 'not_found',
    component: MaintenanceView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Helper function to check if user can access admin features
function canAccessAdminFeatures(store) {
  const activeRole = store.state.activeRole;
  return activeRole === 'ROLE_ADMIN' || activeRole === 'ROLE_CURATOR';
}

// Helper function to check if user has specific role
function hasRole(store, requiredRole) {
  const activeRole = store.state.activeRole;
  return activeRole === requiredRole;
}

// Helper function to check if user has any of the required roles
function hasAnyRole(store, requiredRoles) {
  if (!requiredRoles || !Array.isArray(requiredRoles)) {
    return false;
  }
  
  const activeRole = store.state.activeRole;
  return requiredRoles.includes(activeRole);
}

router.beforeEach(async (to, from, next) => {
  // Check jika halaman tidak ditemukan (akan di-handle oleh catch-all route)
  // Hanya redirect ke maintenance untuk route yang benar-benar tidak valid
  if (to.matched.length === 0 && !to.path.startsWith('/dashboard')) {
    console.log('Route tidak ditemukan:', to.path)
    // Izinkan navigasi normal, biarkan catch-all route yang handle
    next()
    return
  }
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Store.getters.isLoggedIn) {
      next({ path: '/' })
      return
    }
    
    // Ensure roles are loaded
    if (!Store.state.roles || (Array.isArray(Store.state.roles) && Store.state.roles.length === 0)) {
      try {
        await Store.dispatch('get_roles');
      } catch (error) {
        console.error('Failed to get user roles:', error);
        next({ path: '/' })
        return
      }
    }
    
    // Check for admin requirement
    if (to.matched.some(record => record.meta.requiresAdmin)) {
      if (!canAccessAdminFeatures(Store)) {
        // Redirect to dashboard with error message
        next({ path: '/dashboard' })
        return
      }
    }
    
    // Check for specific role requirements
    const requiredRoles = to.matched.reduce((roles, record) => {
      if (record.meta.requiredRoles) {
        return [...roles, ...record.meta.requiredRoles];
      }
      return roles;
    }, []);
    
    if (requiredRoles.length > 0 && !hasAnyRole(Store, requiredRoles)) {
      next({ path: '/dashboard' })
      return
    }
    
    next()
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (Store.getters.isLoggedIn) {
      next({ path: '/dashboard' })
      return
    }
    next()
  } else {
    next()
  }
})

export default router
